<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-cube-outline"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="mr-4">
        <v-col class="white rounded-lg" cols="8">
          <v-col cols="12">
            <v-text-field
                v-model="technologyDetail.name"
                filled
                label="Tên"
                placeholder="Nhập tên"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field
                v-model="technologyDetail.description"
                filled
                label="Mô tả"
                placeholder="Nhập mô tả"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
                v-model="image"
                label="Ảnh"
                placeholder="Tải ảnh lên"
                prepend-icon="mdi-camera"
                @change="uploadImg"
            ></v-file-input>
            <v-img :class="[display_image ? 'mb-8':'d-none']"
                   :src="display_image? display_image :''" aspect-ratio="1.7"
                   contain
                   width="200"
            ></v-img>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn
                color="primary"
                width="180"
                @click="save()"
            >
              Lưu
            </v-btn>
          </v-col>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import {GET_DETAIL_TECHNOLOGY, UPDATE_TECHNOLOGY} from "@/store/modules/technology";
import {mapGetters} from "vuex";
import {UPLOAD_IMAGE} from "@/store/modules/field_project";

export default {
  name: "Edit_tech",
  data(){
    return{
      page: "Sửa technology",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách technology",
          disabled: true,
        },
        {
          text: "Sửa technology",
          disabled: false,
        },
      ],

      image: null,
      display_image: '',
      url: '',

      tech:{
        name:'',
        description:'',
        active:0,
        photo_url:''
      }
    }
  },
  computed: {
    ...mapGetters({
      technologyDetail: "technologyDetail",
    }),
  },
  async created() {
    this.url = process.env.VUE_APP_API_URL
    await this.$store.dispatch(GET_DETAIL_TECHNOLOGY, this.$route.params.id);
  },
  watch: {
    technologyDetail(val) {
      if (val && val.photo_url) {
        this.display_image = this.url + val.photo_url;
      }
    }
  },
  methods:{
    uploadImg(e) {
      if (!e) {
        this.display_image = "";
        this.technologyDetail.photo_url = "";
      }
      this.display_image = URL.createObjectURL(e)
      this.$forceUpdate()
    },

    async save(){
      if (this.image != null) {
        let formDateAvatar = new FormData();
        formDateAvatar.append("upload", this.image);
        formDateAvatar.append("type", "ckeditor");
        formDateAvatar.append("position_type", "1");
        await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
              if (data.data.status == 1) {
                this.technologyDetail.photo_url = data.data.data[0].path
              }
            }
        )
      }
      await this.$store.dispatch(`${UPDATE_TECHNOLOGY}`, this.technologyDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/technology')
        } else {
          alert(data.data.errors)
        }
      });
    }
  }
}
</script>

<style scoped>

</style>